import { Navigate } from "react-router-dom";
import {
  HOME_ROUTE,
  EVENT_ROUTE,
  LK_ROUTE,
  LK_PROFILE_ROUTE,
  USER_ROLES,
  RECORD_CHECK_ROUTE,

} from "shared/config/routes";
import { HomePage } from "pages";
import { EventPageLayout } from "pages";
import { EventPage } from "pages";
import { ProgramPage } from "pages";
import { LkLayout } from "pages/lk";
import { LkProfilePage } from "pages/lk";
import { LkEventsPage } from "pages/lk";
import { RequireAuth } from "../guards/RequireAuth";
import { RequireRole } from "../guards/RequireRole";
import { EventRecords } from "pages/lk";
import { ManagerEvents } from "pages/lk";
import { RecordCheckPage } from "pages/record-check";

export const publicRoutes = [
  {
    path: HOME_ROUTE,
    Component: HomePage,
  },
  {
    path: EVENT_ROUTE,
    Component: EventPageLayout,
    children: [
      {
        index: true,
        Component: EventPage,
      },
      {
        path: "schedule",
        Component: ProgramPage,
      },
    ],
  },
  {
    path: LK_ROUTE,
    Component: () => (
      <RequireAuth>
        <LkLayout />
      </RequireAuth>
    ),
    children: [
      {
        index: true,
        Component: () => <Navigate to={LK_PROFILE_ROUTE} replace />,
      },
      {
        path: "profile",
        Component: () => (
          <RequireRole allowedRoles={[USER_ROLES.CLIENT, USER_ROLES.MANAGER]}>
            <LkProfilePage />
          </RequireRole>
        ),
      },
      {
        path: "events",
        Component: () => (
          <RequireRole allowedRoles={[USER_ROLES.CLIENT, USER_ROLES.MANAGER]}>
            <LkEventsPage />
          </RequireRole>
        ),
        children: [
          {
            index: true,
            Component: () => (
              <RequireRole allowedRoles={[USER_ROLES.MANAGER]}>
                <ManagerEvents />
              </RequireRole>
            ),
          },
          {
            path: ":eventId",
            Component: () => (
              <RequireRole allowedRoles={[USER_ROLES.MANAGER]}>
                <EventRecords />
              </RequireRole>
            ),
          },
        ],
      },
    ],
  },
  {
    path: RECORD_CHECK_ROUTE,
    Component: RecordCheckPage,
  },
];
